import React from 'react';

import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import { openCreateRuleDialog } from 'src/services/rules';

const NoRules = ({ forceReload }) => {
  return (
    <EmptyState
      header="No rules so far"
      description={<span>Start creating rules by clicking <em>Create Rule</em> button.</span>}
      primaryAction={<Button appearance="primary" onClick={openCreateRuleDialog}>Create Rule</Button>}
    />
  );
};

export default NoRules;
